import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const CTA = props => {
  const { title, content, button_url, button_text } = props.cta
  return (
    <div className="c-projects__col c-project-cta u-flex u-flex-sb">
      <div className="c-project-cta__title">{title}</div>
      <div className="c-project-cta__content">{content}</div>
      <div>
        <a
          href={button_url}
          className="c-project-cta__button c-button c-button--white"
        >
          {button_text}
        </a>
      </div>
    </div>
  )
}

export default CTA



// WEBPACK FOOTER //
// ./src/js/blog/components/CTA.js